import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import { atom, useAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { BasicDialog } from '../../../components/Dialog/BasicDialog';
import { FormFieldsContainer } from '../../../components/Form/FormComponents';
import { ViewTypeByData } from '../../../data-models/view-config.data-model';
import { PermissionService } from '../../../services/PermissionService';
import { ViewAction, ViewActionName } from '../../../types';
import { selectedViewPFJ, viewsPFJ } from '../state/ViewStateJ';
import { PromoteViewForm } from './PromoteViewForm';

export const showPromoteViewDialog = atom(false);

const supportedViewTypes = new Set([
  ViewTypeByData.company,
  ViewTypeByData.fund,
  ViewTypeByData.transaction,
  ViewTypeByData.security,
]);

export function usePromoteViewOption(): ViewAction | null {
  const selectedView = useAtomValue(selectedViewPFJ);

  return useMemo(() => {
    if (!selectedView) {
      return null;
    }
    const canPromoteView =
      PermissionService.get().canManageDefaultViews() &&
      supportedViewTypes.has(selectedView.viewType) &&
      !selectedView.isDefault;
    if (!canPromoteView) {
      return null;
    }
    return {
      value: 'Promote View',
      icon: <BookmarkAddIcon />,
      id: ViewActionName.PROMOTE,
    };
  }, [selectedView]);
}

export function PromoteViewDialog() {
  const selectedView = useAtomValue(selectedViewPFJ);
  const allViews = useAtomValue(viewsPFJ);
  const [open, setOpen] = useAtom(showPromoteViewDialog);

  if (!open || !selectedView) {
    return null;
  }

  return (
    <BasicDialog open={open} onClose={() => setOpen(false)} title='Promote View'>
      <FormFieldsContainer>
        <PromoteViewForm selectedView={selectedView} allViews={allViews} />
      </FormFieldsContainer>
    </BasicDialog>
  );
}
